export default __webpack_public_path__ + "static/telesan_inicio3-e735de3b9c0c40bd5ed51a11a2c9589d.jpg";